import { createPath, type Location } from 'react-router-dom';

/**
 * The location a sign-in redirect bounced FROM, carried via `<Navigate state>` — typed once so
 * the writer (`App.tsx`'s route guard) and the reader (this page) cannot disagree about the
 * shape. Always a `Location` react-router itself produced, so always same-origin.
 */
export type LoginRedirectState = { from: Location };

/** The same-origin path (pathname + search + hash) sign-in should return to, or null with none. */
export const readLoginRedirect = (state: unknown): string | null => {
    const from = (state as LoginRedirectState | null)?.from;
    return from ? createPath(from) : null;
};
